import React from 'react';
import styled from 'styled-components';

import {
  asLocalStorageField,
} from 'hive-admin/src/components/FieldLocalStorage';

import getStoreUrl from '../../helpers/getStoreUrl';
import getFilterWithCol from '../../helpers/getFilterWithCol';

import { fieldI18nLanguage } from '../../helpers/i18n';

import {
  // AddSegmentButtonWithModal,
  AfterAddButton,
} from '../../components/FieldContentBuilder/items/index';
import { createChangeLogSection } from '../../components/FieldChangeLog';

export const fieldName = ['FieldText', {
  name: 'name',
  rules: [['validation.isRequired']],
}];

export const fieldSlug = getFilterWithCol(['FieldSlug', {
  name: 'slug',
  // rules: [['validation.isRequired']],
  sendEmpty: true,
  placeholder: 'Link (leave empty for Home Page)',
  copyLinkSegments: [
    (props) => {
      if (props.data && props.data.storeData) {
        return getStoreUrl(props.data.storeData);
      }
      return null;
    },
  ],
  addonBefore: '/',
}], 12);

export const fieldActive = getFilterWithCol(['FieldRadio', {
  name: 'active',
  label: 'Active',
  initialValue: true,
  choices: [
    { value: true, label: 'Active' },
    { value: false, label: 'Inactive' },
  ],
  block: true,
}], 12);

// export const fieldGlobal = ['FieldRadio', {
//   name: 'global',
//   label: 'Scope',
//   block: true,
//   initialValue: false,
//   choices: [{
//     label: 'Store',
//     value: false,
//   }, {
//     label: 'Global',
//     value: true,
//   }],
//   disabled: [tests.activityIsNotCreate],
//   virtual: [tests.activityIsNotCreate],
// }];

export const fieldStore = ['FieldConnectionSelect', {
  name: 'store',
  placeholder: 'Select the page store',
  url: '/stores/list',
  searchPaths: ['name'],
  rules: [['validation.isRequired']],
  disabled: [props => props.activity !== 'create'],
  virtual: [props => props.activity !== 'create'],
}];

export const fieldContentTitle = ['FieldTitle', {
  title: 'Content',
}];

export const FieldContentPlaceholderContentWrapper = styled.div`
  text-align: center;
  h1 {
    font-size: 26px;
  }
  padding-top: 40px;
  padding-bottom: 40px;
`;

export const fieldContent = ['FieldContentBuilderItems', {
  name: 'content',
  // eslint-disable-next-line arrow-body-style
  renderPlaceholderContent: (props, field) => {
    // const isAdmin = props?.viewer?.role === 'ADMIN';
    return (
      <FieldContentPlaceholderContentWrapper>
        <h1>Start with a Template!</h1>
        <p>
          Our curated list of Templates offers an easy way to get you started,
          <br />
          go ahead and load one now!
        </p>
        <AfterAddButton
          field={field}
          props={props}
          getButtons={(buttons) => buttons.reduce(
            (agr, button) => {
              if (button.id === 'LIBRARY_ITEM') {
                agr.push({
                  ...button,
                  label: 'Load Template',
                  defaultSegmentKind: 'TEMPLATE',
                })
              }
              return agr;
            },
            [],
          )}
        />
      </FieldContentPlaceholderContentWrapper>
    );
  },
}];

export const fieldSections = asLocalStorageField(['FieldTitleToggle', {
  name: 'showSections',
  title: 'Sections',
  subtitle: 'Choose which sections are visible on this page.',
}]);

export const fieldsHide = [
  ['announcements', 'Announcements'],
  ['header', 'Header'],
  ['cart', 'Cart'],
  ['footer', 'Footer'],
].map(([name, label]) => ['FieldRadio', {
  name: `layout.${name}.hidden`,
  label: null,
  initialValue: false,
  hidden: [['condition.fieldIsNotTrue', 'showSections']],
  choices: [
    { value: false, label: `Show ${label}` },
    { value: true, label: `Hide ${label}` },
  ],
  block: true,
}]);

export const fieldAdvanced = asLocalStorageField(['FieldTitleToggle', {
  title: 'Advanced',
  subtitle: 'Custom CSS for advanced styling and behavior.',
  name: 'showAdvanced',
  initialValue: false,
}]);

export const fieldCustomCssPicker = ['FieldRadio', {
  name: 'show_custom_css_picker',
  label: null,
  initialValue: 'CSS',
  block: true,
  hidden: [['condition.fieldIsNotTrue', 'showAdvanced']],
  choices: [
    { value: 'CSS', label: 'CSS' },
    { value: 'STITCHES', label: 'Stitches' },
  ],
}];

export const fieldCustomCss = ['FieldCodeEditor', {
  name: 'customCss',
  label: null,
  placeholder: '',
  defaultLanguage: 'css',
  minHeight: '600px',
  hidden: [
    ['condition.fieldIsNotTrue', 'showAdvanced'],
    [
      'condition.testFieldValue',
      'show_custom_css_picker',
      '!==',
      'CSS',
    ],
  ],
  getMonacoEditorOptions: () => ({
    scrollBeyondLastLine: false,
    scrollbar: {
      alwaysConsumeMouseWheel: false,
    },
    minimap: {
      enabled: false,
    },
    contextmenu: false,
    tabSize: 2,
    insertSpaces: true,
    detectIndentation: false,
  }),
}];

export const fieldCustomStitchesCss = ['FieldCodeEditor', {
  name: 'customStitchesCss',
  label: null,
  placeholder: '',
  defaultLanguage: 'json',
  minHeight: '600px',
  hidden: [
    ['condition.fieldIsNotTrue', 'showAdvanced'],
    [
      'condition.testFieldValue',
      'show_custom_css_picker',
      '!==',
      'STITCHES',
    ],
  ],
  getMonacoEditorOptions: () => ({
    scrollBeyondLastLine: false,
    scrollbar: {
      alwaysConsumeMouseWheel: false,
    },
    minimap: {
      enabled: false,
    },
    contextmenu: false,
    tabSize: 2,
    insertSpaces: true,
    detectIndentation: false,
  }),
  prepareValueForInput: (value) => {
    if (typeof value !== 'string') {
      try {
        value = JSON.stringify(value, null, '  ');
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        value = '';
      }
    }
    return value;
  },
}];

export const fieldSeo = asLocalStorageField(['FieldTitleToggle', {
  title: 'SEO & Meta Tags',
  subtitle: 'Add custom meta tags for this page.',
  name: 'showSeo',
  initialValue: false,
}]);

export const fieldCustomMetaTags = ['FieldSortableList', {
  name: 'customMetaTags',
  label: null,
  addButtonLabel: 'Add Meta Tag',
  condensed: true,
  hidden: [['condition.fieldIsNotTrue', 'showSeo']],
  fields: [
    getFilterWithCol(['FieldText', {
      name: 'name',
      label: null,
      placeholder: 'name (e.g., "author", "robots")',
      col: 12,
    }], 12),
    getFilterWithCol(['FieldText', {
      name: 'property',
      label: null,
      placeholder: 'property (e.g., "og:title", "twitter:card")',
      col: 12,
    }], 12),
    ['FieldText', {
      name: 'content',
      label: null,
      placeholder: 'content',
      rules: [['validation.isRequired']],
    }],
  ],
}];

export const ADMIN = [
  fieldI18nLanguage,
  fieldName,
  fieldSlug,
  fieldActive,
  fieldStore,

  fieldContentTitle,
  fieldContent,

  fieldSections,
  ...fieldsHide,

  fieldSeo,
  fieldCustomMetaTags,

  fieldAdvanced,
  asLocalStorageField(fieldCustomCssPicker),

  fieldCustomCss,
  fieldCustomStitchesCss,

  ...createChangeLogSection({
    changeLogConfig: {
      getWhereConditions: props => ({
        store: props.data?.store,
        'target.type': 'Page',
        'target.subject': props.data._id,
      }),
      skipColumns: {
        store: true,
        realm: true,
        target: true,
      },
    },
  }),
];

export const SELLER = [
  fieldI18nLanguage,
  fieldName,
  fieldSlug,
  fieldActive,
  fieldContentTitle,
  fieldContent,

  fieldSections,
  ...fieldsHide,

  fieldSeo,
  fieldCustomMetaTags,

  fieldAdvanced,
  asLocalStorageField(fieldCustomCssPicker),

  fieldCustomCss,
  fieldCustomStitchesCss,
];
